/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { LoggingService } from '../_services/logging/logic/logging.service';
import { DYNFORM_CUSTOM_KEY_PREFIX } from '../_components/dyn-form/form-fields/abstract-form-field/abstract-form-field';

export class UndefinedMissingTranslationHandler
  implements MissingTranslationHandler
{
  constructor(private logger: LoggingService) {}

  handle(params: MissingTranslationHandlerParams): string {
    const currentLang = params.translateService.currentLang;
    for (const lang of ['de', 'en']) {
      if (lang === currentLang) {
        continue;
      }
      const translations = params.translateService.translations[lang];
      if (!translations) {
        continue;
      }
      const value = this.resolveKey(translations, params.key);
      if (value != null) {
        return params.interpolateParams
          ? params.translateService.parser.interpolate(value, params.interpolateParams) ?? ''
          : value;
      }
    }
    return '';
  }

  private resolveKey(translations: any, key: string): string | undefined {
    const value = key.split('.').reduce((obj: any, part: string) => obj?.[part], translations);
    return typeof value === 'string' ? value : undefined;
  }
}
